import React from 'react';
import PropTypes from 'prop-types';

import styles from './ErrorBanner.module.css';

const ErrorBanner = ({ message, 'data-test': dataTest }) => (
  <p className={styles.message} role="alert" data-test={dataTest}>
    {message}
  </p>
);

ErrorBanner.propTypes = {
  message: PropTypes.string.isRequired,
  'data-test': PropTypes.string,
};

ErrorBanner.defaultProps = {
  'data-test': undefined,
};

export default ErrorBanner;
